// Generated file : do not modify
export enum DocumentTypeDateTypes
{
  NONE = 0,
  ANNUEL,
  MENSUEL,
  TRIMESTRIEL,
  PERIODE,
  CREATION,
  MISE_A_JOUR,
  VALIDITE
};

export enum DocumentTypeTitles
{
  NONE = 0,
  REFERENCE,
  ETABLISSEMENT,
  SIGNATAIRE,
  SALARIE,
  INFO
};

import { ListFilter } from '@/extend/classes/ListData';
import Document from '@/extend/classes/Document';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Type de documents
export default class DocumentType  {
  // Identifiant unique
  public id: number;
  // Code
  public code: string;
  // Catégorie
  public categoryId: number;
  // SalarieId requis
  public hasSalarie: boolean;
  // Libellé
  public label: string;
  // Version Excel
  public excel: boolean;
  // Pictogramme
  public picto: string;
  // Type de période
  public dateType: DocumentTypeDateTypes;
  // Titre
  public title: DocumentTypeTitles;
  // Sous-titre
  public subtitle: DocumentTypeTitles;
  // Titre si utilisateur salarié
  public titleSalarie: DocumentTypeTitles;
  // Sous-titre si utilisateur salarié
  public subtitleSalarie: DocumentTypeTitles;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.categoryId = 0;
    this.hasSalarie = false;
    this.label = '';
    this.excel = false;
    this.picto = '';
    this.dateType = DocumentTypeDateTypes.NONE;
    this.title = DocumentTypeTitles.NONE;
    this.subtitle = DocumentTypeTitles.NONE;
    this.titleSalarie = DocumentTypeTitles.NONE;
    this.subtitleSalarie = DocumentTypeTitles.NONE;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: DocumentType): DocumentType {
    const newDocumentType: DocumentType = new DocumentType();
    newDocumentType.id = obj.id;
    newDocumentType.code = obj.code;
    newDocumentType.categoryId = obj.categoryId;
    newDocumentType.hasSalarie = obj.hasSalarie;
    newDocumentType.label = obj.label;
    newDocumentType.excel = obj.excel;
    newDocumentType.picto = obj.picto;
    newDocumentType.dateType = obj.dateType;
    newDocumentType.title = obj.title;
    newDocumentType.subtitle = obj.subtitle;
    newDocumentType.titleSalarie = obj.titleSalarie;
    newDocumentType.subtitleSalarie = obj.subtitleSalarie;
    newDocumentType.createId = obj.createId;
    newDocumentType.failed = obj.failed;
    newDocumentType.canUpdate = obj.canUpdate;
    newDocumentType.canDelete = obj.canDelete;
    newDocumentType.display = obj.display;
    newDocumentType.notifDefType = obj.notifDefType;
    return newDocumentType;
  }

  public toJsonDocumentType (): string {
    const json = {
      code: this.code,
      categoryId: this.categoryId,
      hasSalarie: this.hasSalarie,
      label: this.label,
      excel: this.excel,
      picto: this.picto,
      dateType: this.dateType,
      title: this.title,
      subtitle: this.subtitle,
      titleSalarie: this.titleSalarie,
      subtitleSalarie: this.subtitleSalarie,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromDocumentType (obj: DocumentType): void {
    this.id = obj.id;
    this.code = obj.code;
    this.categoryId = obj.categoryId;
    this.hasSalarie = obj.hasSalarie;
    this.label = obj.label;
    this.excel = obj.excel;
    this.picto = obj.picto;
    this.dateType = obj.dateType;
    this.title = obj.title;
    this.subtitle = obj.subtitle;
    this.titleSalarie = obj.titleSalarie;
    this.subtitleSalarie = obj.subtitleSalarie;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareDocumentType (value: DocumentType): boolean {
    return (this.toJsonDocumentType() == value.toJsonDocumentType());
  }

  public cloneDocumentType (): DocumentType {
    return DocumentType.fromJson(this);
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documenttypes/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listType (document: Document): Promise<DocumentType[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documenttypes/listType', document, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: DocumentType[] = [];
              res.data.forEach(( a: DocumentType ) => {
                cData.push(DocumentType.fromJson(a));
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/DocumentTypes/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = DocumentType.fromJson(listData.reccords[0] as DocumentType);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<DocumentType> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/DocumentTypes/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = DocumentType.fromJson(listData.reccords[0] as DocumentType);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(documentTypes: DocumentType[]) {
  }
}
